{
    "OptionsMenuTitle": "Toon de beschikbare opties voor dit dashboardsubrapport.",
    "DashboardDraggableTitle": "Sleep dit naar een ander rapport in dit dashboard om van plaats te wisselen.",
    "OptionsMenuRemove": "Rapport verwijderen",
    "OptionsMenuAdd": "Nieuw rapport maken",
    "OptionsMenuModify": "Rapport wijzigen",
    "OptionsMenuChange": "Schakelrapport",
    "OptionsMenuChoose": "Kies bestand",
    "OptionMenuUpdateReportError": "Er is een fout opgetreden bij het bijwerken van het dashboardrapport.",
    "OptionMenuRemovePermDelete": "Dit rapport definitief verwijderen",
    "NAME": "DashboardOptions"
}